module.exports = __webpack_public_path__ + "img/img6_6.c0f141c4.jpeg";